/**
 * Shared helpers for Market Insights calendar views.
 * Used by both admin MarketInsightsPanel and user UserMarketPerformanceView.
 */

import {
  type DirectionCall,
  type MarketCondition,
  toMarketCondition,
} from '@parlay-picker/shared/marketCondition';

const CONDITION_STYLES: Record<MarketCondition, { text: string; bg: string }> = {
  great_day: { text: 'text-theme-success', bg: 'bg-theme-success/10' },
  over_day: { text: 'text-theme-primary', bg: 'bg-theme-primary/10' },
  under_day: { text: 'text-purple-400', bg: 'bg-purple-400/10' },
  rough_day: { text: 'text-theme-danger', bg: 'bg-theme-danger/10' },
  average_day: { text: 'text-theme-warning', bg: 'bg-theme-warning/10' },
};

export function getConditionColor(condition: string): string {
  return CONDITION_STYLES[toMarketCondition(condition)].text;
}

export function getConditionBg(condition: string): string {
  return CONDITION_STYLES[toMarketCondition(condition)].bg;
}

/** Colour for a hit rate judged against the break-even of its own picks' odds. */
export function getCallColor(call: DirectionCall): string {
  if (call === 'up') return 'text-theme-success';
  if (call === 'down') return 'text-theme-danger';
  return 'text-theme-warning';
}

export function getHitRateColor(rate: number): string {
  if (rate >= 55) return 'text-theme-success';
  if (rate >= 50) return 'text-theme-warning';
  return 'text-theme-danger';
}
